// First, install the js-sha256 library:
// npm install js-sha256

import { sha256 as jsSha256 } from 'js-sha256';

export const hashPassword = async (password: string): Promise<string> => {
    try {
        console.log('Hashing password:', password);

        // Check if crypto.subtle is available (secure context check)
        if (window.crypto && window.crypto.subtle) {
            // Use Web Crypto API for secure hashing
            const encoder = new TextEncoder();
            const data = encoder.encode(password);

            // SHA-256 is used for the first round of hashing
            const hashBuffer = await crypto.subtle.digest('SHA-256', data);

            // Convert to hex string
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

            return hashHex;
        } else {
            console.warn('Web Crypto API not available - using js-sha256 library');
            // Use the js-sha256 library which produces identical results to crypto.subtle
            return jsSha256(password);
        }
    } catch (error) {
        console.error('Client-side hashing failed:', error);
        // Fall back to the js-sha256 library
        return jsSha256(password);
    }
};
